import React from 'react'

// note - I held off on updating this to use <Fragment> instead of <span>
// because I didn't want to mess with the DOM structure in the notifications
// widget.
export const TextWithBolds = ({ text }) => (
  <span>
    {text && text
      .split(/\*\*([^*]+)\*\*/)
      .map((t, i) => (i % 2 === 0) ? <span key={i}>{t}</span> : <strong key={i}>{t}</strong>)
    }
  </span>
)
